import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { PrivateRate, UpdatePrivateRate } from "@/api/types/offers";
import { IOffer } from "@/api/types/offers";
import { IAffiliateItem } from "@/api/types/user";
import { IAdvertiser } from "@/api/types/revenue";

export const usePrivateRatesStore = defineStore('usePrivateRatesStore', () => {
    // -- List
    const isNeedUpdateRates = ref<boolean>(false);

    // -- Single
    const isNeedUpdateRate = ref<boolean>(false);
    const editableFields = ref<UpdatePrivateRate>({});
    const setEditableFields = (value: UpdatePrivateRate) => {
        Object.assign(editableFields.value, value);
    };

    // -- Create
    const createForm = ref<{
        offerId: null | number;
        offerObj: null | IOffer;
        defaultRate: boolean;
        affiliateId: null | number;
        affiliateObj: null | IAffiliateItem;
        advertiserObj: null | IAdvertiser;
        type: PrivateRate["type"] | null;
        activeRates: null | PrivateRate[];
    }>({
        offerId: null,
        offerObj: null,
        defaultRate: false,
        affiliateId: null,
        affiliateObj: null,
        advertiserObj: null,
        type: null,
        activeRates: null,
    });
    const changedGoals = ref([]);
    const editableActiveRates = ref({});

    const getOfferTags = computed(() => {
        if (createForm.value.offerObj?.tags?.length) {
            return createForm.value.offerObj.tags.map(e => e.id);
        }

        return [];
    });

    const isOfferTrafficAPI = computed<boolean>(() => {
        if (createForm.value.offerObj?.traffics.length) {
            return createForm.value.offerObj.traffics.some(el => el.name === 'API');
        }

        return false;
    });

    const clearForm = (): void => {
        createForm.value = {
            offerId: null,
            offerObj: null,
            defaultRate: false,
            affiliateId: null,
            affiliateObj: null,
            advertiserObj: null,
            type: null,
            activeRates: null,
        };
        changedGoals.value = [];
        editableActiveRates.value = {};
    };

    const isIncludeDepartment = computed<boolean>(() => {
        if (createForm.value.offerObj?.departments.length) {
            return createForm.value.offerObj.departments.some(el =>
                el.name === 'Казахстан' || el.name === 'Мир',
            );
        }

        return false;
    });

    return {
        isNeedUpdateRates,
        isNeedUpdateRate,
        editableFields,
        setEditableFields,
        createForm,
        editableActiveRates,
        changedGoals,
        getOfferTags,
        isOfferTrafficAPI,
        clearForm,
        isIncludeDepartment,
    };
});
